import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "pre-content" };
const _hoisted_2 = { class: "mb-1" };
const _hoisted_3 = {
    key: 0,
    class: "brg-color-black"
};
import { inject, nextTick, onMounted, toRefs, } from 'vue';
import vuexStore from '@/vuex-store';
import { hubSelectorGetterType } from '@/vuex-store/hub-selector/getters';
import AxiosResponse from '@/error/AxiosResponse';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { useWorkerAllocate } from '@/use/useWorkerAllocate';
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import { BusinessError } from '@/error';
import router from '@/router';
import { pStore } from '@/pinia';
import WorkerList from './WorkerList.vue';
import WorkerOrderList from './WorkerOrderList.vue';
import WorkerAllocateHeader from './WorkerAllocateHeader.vue';
import TargetOrder from './TargetOrder.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        draggable: { type: Boolean, default: true },
        dialogCssClass: { default: '' },
        width: { default: 1200 },
        height: { default: 700 },
        onClose: { type: Function, default: undefined }
    },
    setup(__props) {
        // 라이더 배차 다이얼로그
        const props = __props;
        const { dialogCssClass, width, height, } = toRefs(props);
        const pWorkerAllocateDialog = pStore.piniaWorkerAllocate;
        const { popupId, selectedOrder, selectedWorker, distId, hubId, orderId, getOrder, getFulfillment, isDialogOpen, checkIsHideCloseBtn, injectQSToPinia, } = useWorkerAllocate();
        const injectDebugIsLocalhost = inject('$debugIsLocalhost');
        /**
         * 배차 적용 버튼 클릭 핸들러
         */
        const handleClickApplyDialogBtn = () => { };
        /**
         * 닫기 버튼 클릭 핸들러
         */
        const handleClickCancelDialogBtn = () => {
            // props로 넘어온 함수가 있으면 실행
            if (props.onClose) {
                props.onClose();
                // return;
            }
            // vuexStore.dispatch(workerAllocateActionType.dialogClose);
            // vuexStore.dispatch(workerAllocateActionType.reset);
        };
        /**
         * distId, hubId 가 없다면 로그인 계정 데이터 이용
         */
        const initDistHubId = async () => {
            distId.value = distId.value || vuexStore.getters[hubSelectorGetterType.getterSubscribeOnlyDistId];
            hubId.value = hubId.value || vuexStore.getters[hubSelectorGetterType.getterSubscribeOnlyHubId];
        };
        /**
         * 초기화
         */
        const init = async () => {
            try {
                if (window.opener) {
                    window.opener[popupId].open = true;
                }
                else {
                    window[popupId] = {
                        open: true,
                    };
                }
                await initDistHubId();
                if (!orderId.value || !distId.value) {
                    throw new BusinessError({
                        message: '주문 혹은 총판 정보는 필수 입니다.',
                    });
                }
                await pWorkerAllocateDialog.resetFilterOption();
                await getOrder();
                await getFulfillment();
            }
            catch (error) {
                console.log('onMounted', error);
                if (error instanceof BusinessError) {
                    vuexStore.dispatch(snackbarActionType.showError, error.message);
                }
                if (error instanceof AxiosResponse) {
                    vuexStore.dispatch(snackbarActionType.showError, error.data.error.message);
                }
            }
        };
        /**
         * 배차 주문 변경
         */
        const changeWorkerAllocateOrder = async (_distId = '', _hubId = '', _orderId = '') => {
            await router.replace({
                query: {
                    distId: _distId,
                    hubId: _hubId,
                    orderId: _orderId,
                },
            }).catch(() => { });
            await nextTick();
            await injectQSToPinia();
            init();
        };
        /**
         * 초기화
         */
        onMounted(async () => {
            window.changeWorkerAllocateOrder = changeWorkerAllocateOrder;
            init();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                draggable: _ctx.draggable,
                resize: true,
                "no-click-animation": true,
                scrim: false,
                persistent: true,
                horizontal: "",
                "is-open": _unref(isDialogOpen),
                "is-hide-close-btn": _unref(checkIsHideCloseBtn),
                "on-apply": handleClickApplyDialogBtn,
                "on-cancel": handleClickCancelDialogBtn,
                "has-footer": false,
                "has-left-title": false,
                "has-right-title": false,
                "has-horizontal-header": "",
                width: _unref(width),
                height: _unref(height),
                "dialog-css-class": `ratio-5-5 ${_unref(dialogCssClass)}`,
                "is-empty-box": ""
            }, {
                title: _withCtx(() => [
                    _cache[0] || (_cache[0] = _createTextVNode(" 라이더 조회 배차 ")),
                    (_unref(injectDebugIsLocalhost)())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" debug (당일순번: " + _toDisplayString(_unref(selectedOrder)?.todayNumber) + " / 주문아이디: " + _toDisplayString(_unref(selectedOrder)?.orderId) + ") ", 1 /* TEXT */),
                            _createElementVNode("div", null, " ( " + _toDisplayString(_unref(distId)) + " / " + _toDisplayString(_unref(hubId)) + " ) ", 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ]),
                horizontalHeader: _withCtx(() => [
                    _createVNode(WorkerAllocateHeader)
                ]),
                preContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-1 body2-text" }, " 라이더 리스트 ", -1 /* CACHED */)),
                        _createCommentVNode(" 풀피먼트 "),
                        _createVNode(WorkerList)
                    ])
                ]),
                leftContent: _withCtx(() => [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-1" }, " 선택된 주문 ", -1 /* CACHED */)),
                    _createCommentVNode(" 선택된 주문 == 배차할 주문 "),
                    _createVNode(TargetOrder)
                ]),
                rightContent: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _cache[3] || (_cache[3] = _createTextVNode(" 라이더 수행현황 ")),
                        (_unref(selectedWorker))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (" + _toDisplayString(_unref(selectedWorker).workerName) + " 라이더) ", 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createCommentVNode(" 라이더의 수행 상황 "),
                    _createVNode(WorkerOrderList)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["draggable", "is-open", "is-hide-close-btn", "width", "height", "dialog-css-class"]));
        };
    }
});
